import { renderMarkdown } from "@/lib/utils";
import { CloseCircle, InfoCircle } from "iconsax-react";
import { AnimatePresence, motion } from "motion/react";
import { FC, useState } from "react";

type QuestionMetaItemProps = {
  title: string;
  description: string;
};

const QuestionMetaItem: FC<QuestionMetaItemProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const Icon = isOpen ? CloseCircle : InfoCircle;

  return (
    <div>
      <div
        className="items-top flex cursor-pointer gap-2 hover:text-[#293038]"
        onClick={handleToggle}
      >
        <Icon className="mt-0.5 shrink-0" size={16} onClick={handleToggle} />

        <div className="font-bold">{props.title}</div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="pl-6"
            initial={{ height: 0, translateY: -10, opacity: 0 }}
            animate={{
              height: isOpen ? "auto" : 0,
              translateY: 0,
              opacity: 1,
            }}
            exit={{ height: 0, translateY: -10, opacity: 0 }}
            transition={{ duration: 0.1 }}
          >
            <div
              className="pt-2"
              dangerouslySetInnerHTML={{
                __html: renderMarkdown(props.description),
              }}
            ></div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default QuestionMetaItem;
